import React, { useEffect, useState } from 'react';
import { DialogActions, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';

import CustomButton from '../../../../../../../../../../../lib/designSystem/Button';
import {
  getCreditRequestEvaluationMissingApprovals,
  makeCreditRequestApproval,
  makeCreditRequestReject,
} from '../../../../../../../../../../../lib/api/creditRequest/Evaluation';
import { useDispatch, useSelector } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../../lib/designSystem/CircularProgress';
import { showAlert, validatePermissions } from '../../../../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../../../../services/redux/authSlice';
import MissingApprovalContainer from '../../../../../../../../../../../pages/Finance/Components/Financing/Factoring/components/Recieved/components/ShoppingDialog/components/Risk/components/ApprovalModule/MissingApprovalContainer';
import ComiteeUpdateDialog from './components/comiteeUpdate';
import DeleteComiteRevision from './components/DeleteRevision';

const CreditRequestApprovalContainer = (props: any) => {
  const {
    setOpenShoppingCart,
    openRequest,
    setSuccessOpen,
    setUp,
    setFailureOpen,
  } = props;
  const [approvalsRequired, setApprovalsRequired] = useState<any[]>([]);
  const [approvals, setApprovals] = useState<any[]>([]);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [canApprove, setCanApprove] = useState(false);
  const [comitee, setComitee] = useState<any>(null);
  const [table, setTable] = useState<any>('comitee');
  const [openComiteeUpdate, setOpenComiteeUpdate] = useState(false);
  const [openDeleteReview, setOpenDeleteReview] = useState(false);
  const [selectedUserRoleId, setSelectedUserRoleId] = useState<number | ''>('');
  const [userRoles, setUserRoles] = useState<{ name: string }[]>([]);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const setUpApprovals = async () => {
    setLoading(true);
    try {
      const responseApprovals =
        await getCreditRequestEvaluationMissingApprovals(
          dispatch,
          openRequest.id,
        );
      setApprovalsRequired(responseApprovals.rolesToApprove);
      setApprovals(responseApprovals.approvals);
      setComitee(responseApprovals.comitee);
      const userRolesList = Array.isArray(user?.roles) ? user.roles : [];
      const requiredRoleIds = new Set(
        responseApprovals.rolesToApprove.filter((r: any) => !r.approved).map((r: any) => r.id)
      );
      const approvedRoleIds = new Set(
        responseApprovals.approvals.filter((a: any) => a.userId === user?.id).map((a: any) => a.roleId)
      );
      const userRolesWithoutApproval = userRolesList.filter(
        (userRole: any) =>
          requiredRoleIds.has(userRole.id) && !approvedRoleIds.has(userRole.id)
      );
      const canApprove =
        userRolesWithoutApproval.length > 0 &&
        responseApprovals.rolesToApprove.some((entry: any) => entry.userCanApprove);
      setCanApprove(canApprove);
      if (openRequest.status === 'Rechazada') {
        setCanApprove(false);
      }
      setUserRoles(userRolesWithoutApproval);
      if (userRolesWithoutApproval.length === 1) {
        setSelectedUserRoleId((userRolesWithoutApproval[0] as any).id);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleApprove = async () => {
    setLoading(true);
    try {
      await makeCreditRequestApproval(dispatch, openRequest.id, {
        message: reason,
        userRoleId:selectedUserRoleId
      });
      setOpenShoppingCart(false);
      showAlert(
        dispatch,
        'success',
        'Hemos dado tu aprobación a la Línea de crédito.',
      );      await setUp();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleReject = async () => {
    setLoading(true);
    try {
      await makeCreditRequestReject(dispatch, openRequest.id, {
        message: reason,
        userRoleId: selectedUserRoleId
      });
      setOpenShoppingCart(false);
      showAlert(
        dispatch,
        'success',
        'Hemos dado tu rechazo a la Línea de crédito.',
      );      
      await setUp();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const canEdit =
    openRequest.status === 'Asignada' ||
    openRequest.status === 'En revisión' ||
    openRequest.status === 'Activa';

  useEffect(() => {
    setUpApprovals();
  }, []);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <MissingApprovalContainer
        approvals={approvals}
        missingApprovals={approvalsRequired}
        comitee={comitee}
        table={table}
        setTable={setTable}
      />
      {openRequest.status === 'Rechazada' && (
        <Typography variant="body1" color="error" fontWeight="bold">
          Esta solicitud ha sido rechazada
        </Typography>
      )}
      {canApprove && (
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <TextField
            margin="normal"
            label="Motivo"
            value={reason}
            multiline
            onChange={(e) => setReason(e.target.value)}
            style={{ flex: 1 }}
          />
          {userRoles && (
            <FormControl margin="normal" style={{ minWidth: 200, alignSelf: 'stretch', display: 'flex', justifyContent: 'center' }}>
              <InputLabel id="firmas-como-label">Firmas como</InputLabel>
              <Select
                labelId="firmas-como-label"
                id="firmas-como-select"
                value={selectedUserRoleId}
                label="Firmas como"
                onChange={(e) => setSelectedUserRoleId(e.target.value as number)}
              >
                {userRoles.map((role: any) => (
                  <MenuItem key={role.id} value={role.id}>
                    {role.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>  
      )}
      <DialogActions>
        {validatePermissions(user, 'comitee_change') && canEdit && (
          <CustomButton
            onClick={() => setOpenComiteeUpdate(true)}
            color="warning"
          >
            Comité
          </CustomButton>
        )}
        {validatePermissions(user, 'comitee_delete_approval') && canEdit && (
          <CustomButton onClick={() => setOpenDeleteReview(true)} color="error">
            Borrar revisión
          </CustomButton>
        )}
        <CustomButton
          onClick={() => setOpenShoppingCart(false)}
          color="secondary"
        >
          Cerrar
        </CustomButton>
        <CustomButton
          onClick={handleReject}
          color="error"
          variant="contained"
          disabled={!canApprove}
        >
          Rechazar
        </CustomButton>
        <CustomButton
          onClick={handleApprove}
          color="success"
          variant="contained"
          disabled={!canApprove}
        >
          Aprobar
        </CustomButton>
      </DialogActions>
      {openComiteeUpdate && (
        <ComiteeUpdateDialog
          openRequest={openRequest}
          open={openComiteeUpdate}
          setOpen={setOpenComiteeUpdate}
          setFailure={setFailureOpen}
          setUp={setUpApprovals}
          setSuccess={setSuccessOpen}
          setBigOpen={setOpenShoppingCart}
          comitee={comitee}
        />
      )}
      {openDeleteReview && (
        <DeleteComiteRevision
          openRequest={openRequest}
          open={openDeleteReview}
          setOpen={setOpenDeleteReview}
          setFailure={setFailureOpen}
          setUp={setUpApprovals}
          setSuccess={setSuccessOpen}
          setBigOpen={setOpenShoppingCart}
        />
      )}
    </div>
  );
};

export default CreditRequestApprovalContainer;
